import { render, staticRenderFns } from "./menu-blog.vue?vue&type=template&id=27f6b334&scoped=true&"
import script from "./menu-blog.vue?vue&type=script&lang=js&"
export * from "./menu-blog.vue?vue&type=script&lang=js&"
import style0 from "./menu-blog.vue?vue&type=style&index=0&id=27f6b334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6b334",
  null
  
)

export default component.exports